import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import Headline from "../../components/Headline";
import { MainLayout } from "../../components/Layout";
import { BiLoaderAlt } from "react-icons/bi";
import "./styles.scss";

interface VerifyCodePageProps {
    onVerifyCode: (code: string) => Promise<void>;
    goBack: () => void;
    onCodeChange: (e) => void;
    isLoading: boolean;
    code: string;
}

const CODE_LENGTH = 6;
const CODE_MAP = [...Array(CODE_LENGTH)].map((_, i) => i);

const schema = yup.object().shape({
    code: yup
        .string()
        .required("コードを入力してください")
        .matches(/^[\d]{6}$/, "コードは6桁の数字です")
});

const VerifyCodePage = (props: VerifyCodePageProps) => {
    const [isCodeFocus, setIsCodeFocus] = useState(false);
    const { handleSubmit } = useForm({
        mode: "all",
        resolver: yupResolver(schema)
    });
    const onSubmit = async (data) => {
        await props.onVerifyCode(data.code);
    };
    const onFocus = () => {
        setIsCodeFocus(true);
    };
    const onBlur = () => {
        setIsCodeFocus(false);
    };

    return (
        <MainLayout isBurgerHidden={true}>
            <Headline>メール認証</Headline>
            <div className="input-code-label">
                入力いただいたメールアドレスへ認証コードをお送りしました。
                <br />
                メールに記載の認証コードを入力してください。
            </div>
            <div className="input-code-info">
                <span>※</span>有効期限は15分です
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className="form">
                <div className="code-digit-container">
                    <input
                        className="hidden-input"
                        name="code"
                        type="text"
                        inputMode="numeric"
                        pattern="\d*"
                        onChange={props.onCodeChange}
                        autoComplete="off"
                        maxLength={CODE_LENGTH}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        disabled={props.isLoading}
                    />
                    {CODE_MAP.map((i) => {
                        return (
                            <div
                                key={i}
                                className={
                                    "code-digit" +
                                    (props.code.length === i && isCodeFocus
                                        ? " active-input"
                                        : "") +
                                    (props.isLoading ? " non-active" : "")
                                }
                            >
                                {i < props.code.length
                                    ? props.code.length - 1 === i
                                        ? [...props.code][i]
                                        : "●"
                                    : ""}
                            </div>
                        );
                    })}
                    {props.isLoading ? (
                        <BiLoaderAlt className="loader" size="30" />
                    ) : null}
                </div>
            </form>
            <div className="spacer"></div>
            <div className="resend-code">
                <button onClick={props.goBack}>認証コードを再送する</button>
            </div>
        </MainLayout>
    );
};

export default VerifyCodePage;
